export const MODEL = {
    FULL_HEBREW: 'FullHebrew',
    MODERN_HEBREW: 'ModernHebrew',
    RABBINIC_HEBREW: 'RabbinicHebrew',
    MODERN_PROSE_HEBREW: 'ModernProseHebrew',
    ENGLISH:  'English'
};

export const URLS = {
    BASE: '',
    MODEL: '/getmodels',
    SUGGESTIONS: '/typeahead',
    IDENTITY: '/identify',
    EMAIL: 'https://formspree.io/dicta@dicta.org.il'
};

export const PAGES = {
    EN: 'en',
    HE: 'he'
};



// WEBPACK FOOTER //
// ./src/common/Globals.js